module.exports = __webpack_public_path__ + "img/accepted-icon.32472415.png";